import { render } from "./ListStatus.vue?vue&type=template&id=00bb1aa8"
import script from "./ListStatus.vue?vue&type=script&lang=js"
export * from "./ListStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/ListStatus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00bb1aa8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00bb1aa8', __exports__)) {
    api.reload('00bb1aa8', __exports__)
  }
  
  module.hot.accept("./ListStatus.vue?vue&type=template&id=00bb1aa8", () => {
    api.rerender('00bb1aa8', render)
  })

}


export default __exports__